"use client";

import { useEffect, useRef } from "react";
import classes from "./HeaderDropdown.module.scss";
import Dropdown from "@/components/Dropdown/Dropdown";
import Arrow from "@/assets/icons/Arrow";
import { useDropdownContext } from "./HeaderDropdownContext/HeaderDropdownContext";
import { useTheme } from "@/components/ThemeProvider/ThemeProvider";

interface HeaderDropdownProps {
  dropdownName: string;
  options: { title: string; link: string }[];
}

const HeaderDropdown = ({ dropdownName, options }: HeaderDropdownProps) => {
  const { activeDropdown, setActiveDropdown } = useDropdownContext();

  const dropdownRef = useRef<HTMLDivElement>(null);

  const isActive = activeDropdown === dropdownName;

  const { theme } = useTheme();

  const arrowColor = theme === "light" ? "#FFFFFF" : "#CCCCCC";

  const dropdownClickHandler = () => {
    setActiveDropdown(isActive ? null : dropdownName);
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setActiveDropdown(null);
      }
    };

    if (isActive) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isActive, setActiveDropdown]);

  return (
    <div
      ref={dropdownRef}
      className={
        isActive
          ? `${classes["high-emitting-dropdown-container"]} ${classes["high-emitting-dropdown-container-active"]}`
          : classes["high-emitting-dropdown-container"]
      }
      onClick={dropdownClickHandler}
    >
      {dropdownName} <Arrow rotation={isActive ? 180 : 0} color={arrowColor} />
      <div
        className={
          !isActive
            ? classes["dropdown-wrapper"]
            : `${classes["dropdown-wrapper"]} ${classes["dropdown-wrapper-active"]}`
        }
      >
        <Dropdown optionArr={options} dropdownVisibility={isActive} />
      </div>
    </div>
  );
};

export default HeaderDropdown;
